module.exports = __webpack_public_path__ + "sflyssofe.8dc5fcf202.svg";